module.exports = __webpack_public_path__ + "static/media/RanjanaV4.3234c51b.jpg";